<template>
  <div :class="['summary-box', {'no-top':notop}]">
    <div class="computation-box">
      <div class="cb-title">Price Summary</div>
      <table cellspacing="0">
        <tr>
          <td colspan="2" class="td-label">
            <b v-if="isReturning">
              <i class="fas fa-plane"></i>
              Roundtrip Flight
            </b>
            <b v-else>
              {{ selectedLeg1.flight[0].origin.AirportName }} ({{ selectedLeg1.flight[0].origin.AirportCode }})
              to
              {{ selectedLeg1.flight[selectedLeg1.flight.length - 1].destination.AirportName }} ({{ selectedLeg1.flight[selectedLeg1.flight.length - 1].destination.AirportCode }})
            </b>
            <div>
              <span>Taxes, fees and charges</span>
            </div>
            <span>{{ dateFormat(selectedLeg1.flight[0].origin.DateTime) }}</span>
            <span v-if="isReturning">- {{ dateFormat(selectedLeg2Flight[0].origin.DateTime) }}</span>
          </td>
          <td v-if="isReturning" class="val" valign="top">
            <!-- <span v-if="currency.code === 'USD'">$ {{priceFormat(baseFareWithMarkup + baseFareWithMarkupReturn)}}</span>
            <span v-else>{{applyCurrency(baseFareWithMarkup + baseFareWithMarkupReturn)}}</span> -->
            <span v-if="currency.code === 'USD'">$ {{priceFormat(getAirFare + getAirFareReturn)}}</span>
            <span v-else>{{applyCurrency(getAirFare + getAirFareReturn)}}</span>
          </td>
          <td v-else class="val" valign="top">
            <!-- <span v-if="currency.code === 'USD'">$ {{priceFormat(baseFareWithMarkup)}}</span>
            <span v-else>{{applyCurrency(baseFareWithMarkup)}}</span> -->
            <span v-if="currency.code === 'USD'">$ {{priceFormat(getAirFare)}}</span>
            <span v-else>{{applyCurrency(getAirFare)}}</span>
          </td>
        </tr>

        <tr v-if="!hideGround.pickup || !hideGround.dropoff">
          <td colspan="3"><hr/></td>
        </tr>

        <tr v-if="!hideGround.pickup || !hideGround.dropoff">
          <td colspan="3" class="td-label">
            <b>
              <i class="fas fa-car-side"></i>
              Ground Transportation
            </b>
          </td>
        </tr>

        <!-- #GROUND #1 -->
        <tr :class="['ground-service', {removed:!ground0}]" v-if="!hideGround.pickup">
          <td class="gs-check">
            <img src="../../assets/img/car-transport.svg" />
            <input type="checkbox" v-model="ground0" @click="toggleGround(0)" />
          </td>
          <td class="gs-name">
            <b>{{ findService('leg1', 'pickup', groundLeg1Pickup).name }}</b>
          </td>
          <td class="val" valign="top" v-if="!ground0">
            <span>{{applyCurrency(0)}}</span>
          </td>
          <td class="val" valign="top" v-else>
            <!-- <span v-if="isZero(landFeePickup) || leg1Free" class="free-label">FREE</span>
            <span v-else-if="currency.code === 'USD'">{{priceFormat(landFeePickup, true)}}</span>
            <span v-else>{{applyCurrency(landFeePickup)}}</span> -->
            <span v-if="leg1Free" class="free-label">FREE</span>
            <div v-else>
              <div>
                <span v-if="leg1Discount.value > 0" class="free-label">{{ dcLabel(leg1Discount) }} OFF</span>
              </div>

              <div v-if="leg1Discount.value > 0" class="ground-price orig">
                <span v-if="currency.code === 'USD'">{{ priceFormat(landFeePickup, true) }}</span>
                <span v-else>{{ applyCurrency(landFeePickup) }}</span>
              </div>
              <div v-else-if="landFeePickup != landFeePickupOrig" class="ground-price orig">
                <span v-if="currency.code === 'USD'">{{ priceFormat(landFeePickupOrig, true) }}</span>
                <span v-else>{{ applyCurrency(landFeePickupOrig) }}</span>
              </div>

              <span v-if="currency.code === 'USD'">{{ priceFormat(landFeePickupDiscounted, true) }}</span>
              <span v-else >{{ applyCurrency(landFeePickupDiscounted) }}</span>
            </div>
          </td>
        </tr>
        <tr :class="['ground-loc', {removed:!ground0}]" v-if="!hideGround.pickup">
          <td></td>
          <td class="gl-loc">
            <b>Pickup:</b> {{ locations.pickup.title }}
            <br/>
            <b>Dropoff:</b> {{ locations.pickupAirport.name }} ({{locations.pickupAirport.code}})
          </td>
          <td></td>
        </tr>

        <!-- #GROUND #2 -->
        <tr :class="['ground-service', {removed:!ground1}]" v-if="!hideGround.dropoff">
          <td class="gs-check">
            <img src="../../assets/img/car-transport.svg" />
            <input type="checkbox" v-model="ground1" @click="toggleGround(1)" />
          </td>
          <td class="gs-name">
            <b>{{ findService('leg1', 'dropoff', groundLeg1Dropoff).name }}</b>
          </td>
          <td class="val" valign="top" v-if="!ground1">
            <span>{{applyCurrency(0)}}</span>
          </td>
          <td class="val" valign="top" v-else>
            <!-- <span v-if="isZero(landFeeDropoff) || leg2Free" class="free-label">FREE</span>
            <span v-else-if="currency.code === 'USD'">{{priceFormat(landFeeDropoff, true)}}</span>
            <span v-else>{{applyCurrency(landFeeDropoff)}}</span> -->
            <span v-if="leg2Free" class="free-label">FREE</span>
            <div v-else>
              <div>
                <span v-if="leg2Discount.value > 0" class="free-label">{{ dcLabel(leg2Discount) }} OFF</span>
              </div>

              <div v-if="leg2Discount.value > 0" class="ground-price orig">
                <span v-if="currency.code === 'USD'">{{ priceFormat(landFeeDropoff, true) }}</span>
                <span v-else>{{ applyCurrency(landFeeDropoff) }}</span>
              </div>
              <div v-else-if="landFeeDropoff != landFeeDropoffOrig" class="ground-price orig">
                <span v-if="currency.code === 'USD'">{{ priceFormat(landFeeDropoffOrig, true) }}</span>
                <span v-else>{{ applyCurrency(landFeeDropoffOrig) }}</span>
              </div>

              <span v-if="currency.code === 'USD'">{{ priceFormat(landFeeDropoffDiscounted, true) }}</span>
              <span v-else >{{ applyCurrency(landFeeDropoffDiscounted) }}</span>
            </div>
          </td>
        </tr>
        <tr :class="['ground-loc', {removed:!ground1}]" v-if="!hideGround.dropoff">
          <td></td>
          <td class="gl-loc">
            <b>Pickup:</b> {{ locations.dropoffAirport.name }} ({{locations.dropoffAirport.code}})
            <br/>
            <b>Dropoff:</b> {{ locations.dropoff.title }}
          </td>
          <td></td>
        </tr>

        <!-- #GROUND #3 -->
        <tr :class="['ground-service', {removed:!ground2}]" v-if="isReturning && !hideGround.dropoff">
          <td class="gs-check">
            <img src="../../assets/img/car-transport.svg" />
            <input type="checkbox" v-model="ground2" @click="toggleGround(2)" />
          </td>
          <td class="gs-name">
            <b>{{ findService('leg2', 'pickup', groundLeg2Pickup).name }}</b>
          </td>
          <td class="val" valign="top" v-if="!ground2">
            <span>{{applyCurrency(0)}}</span>
          </td>
          <td class="val" valign="top" v-else>
            <!-- <span v-if="isZero(landFeePickupReturn) || leg3Free" class="free-label">FREE</span>
            <span v-else-if="currency.code === 'USD'">{{priceFormat(landFeePickupReturn, true)}}</span>
            <span v-else>{{applyCurrency(landFeePickupReturn)}}</span> -->
            <span v-if="leg3Free" class="free-label">FREE</span>
            <div v-else>
              <div>
                <span v-if="leg3Discount.value > 0" class="free-label">{{ dcLabel(leg3Discount) }} OFF</span>
              </div>

              <div v-if="leg3Discount.value > 0" class="ground-price orig">
                <span v-if="currency.code === 'USD'">{{ priceFormat(landFeePickupReturn, true) }}</span>
                <span v-else>{{ applyCurrency(landFeePickupReturn) }}</span>
              </div>
              <div v-else-if="landFeePickupReturn != landFeePickupOrigReturn" class="ground-price orig">
                <span v-if="currency.code === 'USD'">{{ priceFormat(landFeePickupOrigReturn, true) }}</span>
                <span v-else>{{ applyCurrency(landFeePickupOrigReturn) }}</span>
              </div>

              <span v-if="currency.code === 'USD'">{{ priceFormat(landFeePickupReturnDiscounted, true) }}</span>
              <span v-else >{{ applyCurrency(landFeePickupReturnDiscounted) }}</span>
            </div>
          </td>
        </tr>
        <tr :class="['ground-loc', {removed:!ground2}]" v-if="isReturning && !hideGround.dropoff">
          <td></td>
          <td class="gl-loc">
            <b>Pickup:</b> {{ locations.dropoff.title }}
            <br/>
            <b>Dropoff:</b> {{ locations.dropoffAirport.name }} ({{locations.dropoffAirport.code}})
          </td>
          <td></td>
        </tr>

        <!-- #GROUND #4 -->
        <tr :class="['ground-service', {removed:!ground3}]" v-if="isReturning && !hideGround.pickup">
          <td class="gs-check">
            <img src="../../assets/img/car-transport.svg" />
            <input type="checkbox" v-model="ground3" @click="toggleGround(3)" />
          </td>
          <td class="gs-name">
            <b>{{ findService('leg2', 'dropoff', groundLeg2Dropoff).name }}</b>
          </td>
          <td class="val" valign="top" v-if="!ground3">
            <span>{{applyCurrency(0)}}</span>
          </td>
          <td class="val" valign="top" v-else>
            <!-- <span v-if="isZero(landFeeDropoffReturn) || leg4Free" class="free-label">FREE</span>
            <span v-else-if="currency.code === 'USD'">{{priceFormat(landFeeDropoffReturn, true)}}</span>
            <span v-else>{{applyCurrency(landFeeDropoffReturn)}}</span> -->
            <span v-if="leg4Free" class="free-label">FREE</span>
            <div v-else>
              <div>
                <span v-if="leg4Discount.value > 0" class="free-label">{{ dcLabel(leg4Discount) }} OFF</span>
              </div>

              <div v-if="leg4Discount.value > 0" class="ground-price orig">
                <span v-if="currency.code === 'USD'">{{ priceFormat(landFeeDropoffReturn, true) }}</span>
                <span v-else>{{ applyCurrency(landFeeDropoffReturn) }}</span>
              </div>
              <div v-else-if="landFeeDropoffReturn != landFeeDropoffOrigReturn" class="ground-price orig">
                <span v-if="currency.code === 'USD'">{{ priceFormat(landFeeDropoffOrigReturn, true) }}</span>
                <span v-else>{{ applyCurrency(landFeeDropoffOrigReturn) }}</span>
              </div>

              <span v-if="currency.code === 'USD'">{{ priceFormat(landFeeDropoffReturnDiscounted, true) }}</span>
              <span v-else >{{ applyCurrency(landFeeDropoffReturnDiscounted) }}</span>
            </div>
          </td>
        </tr>
        <tr :class="['ground-loc', {removed:!ground3}]" v-if="isReturning && !hideGround.pickup">
          <td></td>
          <td class="gl-loc">
            <b>Pickup:</b> {{ locations.pickupAirport.name }} ({{locations.pickupAirport.code}})
            <br/>
            <b>Dropoff:</b> {{ locations.pickup.title }}
          </td>
          <td></td>
        </tr>

        <!-- <tr>
          <td colspan="3"><hr/></td>
        </tr> -->

        <!-- <tr class="tr-tax">
          <td colspan="2">
            <b>Taxes, fees and charges</b>
            <i class="fas fa-info-circle"></i>
          </td>
          <td class="val">
            <span v-if="currency.code === 'USD'">$ {{priceFormat(tax)}}</span>
            <span v-else>{{applyCurrency(tax)}}</span>
          </td>
        </tr> -->

        <tr>
          <td colspan="3"><hr/></td>
        </tr>

        <tr class="tr-breakdown" v-if="showBreakdown && other.widgetTab === 'd2d' && isReturning && totalDiscount">
          <td colspan="2" style="padding-top: 7px; line-height: 1;" valign="top">
            Discount
          </td>
          <td class="val dc-txt" valign="top" style="padding-top: 7px; line-height: 1;">
            <span>-{{applyCurrency(totalDiscount)}}</span>
          </td>
        </tr>
        <tr class="tr-breakdown" v-if="showBreakdown && other.widgetTab === 'd2d' && isReturning && totalDiscount && totalLegsCount > 1">
          <td colspan="3" style="line-height: 1;">
            <span class="upto">(up to {{applyCurrency(totalDiscount/totalLegsCount)}} For Each Ground Transportation Ride)</span>
          </td>
        </tr>

        <tr class="credits" v-if="user.token">
          <td colspan="3">
            <div class="d-flex justify-space-between align-start">
              <span>Credits</span>
              <span v-if="currency.code === 'USD'">-{{priceFormat(credits, true)}}</span>
              <span v-else>-{{applyCurrency(credits)}}</span>
            </div>
          </td>
        </tr>
        <tr v-if="user.token">
          <td colspan="3" class="redeem" @click="showRedeem">Redeem Promo Code</td>
        </tr>
        <tr v-if="user.token">
          <td colspan="3"><hr/></td>
        </tr>

        <tr class="total">
          <td colspan="3">
            <div class="d-flex justify-space-between align-start">
              <span>
                Trip Total
                <!-- <span class="incl-taxes">(Incl. of All taxes and Fee)</span> -->
              </span>
              <span v-if="currency.code === 'USD'">{{priceFormat(total, true)}}</span>
              <span v-else>{{applyCurrency(total)}}</span>
            </div>
          </td>
        </tr>
      </table>
      <div>
        <div :class="['lr-btn', {disabled:flightPrice.loading || flightPrice.error}]" @click="proceedToPax" v-if="showProceed">
          Continue
          <i class="fas fa-spinner fa-spin fa-fw" v-if="flightPrice.loading"></i>
        </div>
        <div class="lr-btn" @click="initBook(false)" v-if="showBook && false">Book this Flight</div>
        <!-- <a class="change-flight" @click="back" v-if="showProceed">Change Flight Plans</a> -->
        <!-- <a class="change-flight" @click="back2" v-if="showProceed2">Back</a> -->
      </div>
    </div>

    <div class="disclaimer-box" v-if="other.widgetTab === 'd2d'">
      * <b>{{ brandLabel }} Flights</b> pricing includes all airport transfers, flights and is inclusive of all taxes and fees.
      When you book with {{ brandLabel }}, your trip is from your door to your final destination.
    </div>
  </div>
</template>

<script>
/* global CONFIG */
const request = require('browser-request')
import moment from 'moment-timezone'
import { customAlphabet } from 'nanoid'
const countries = require('@/data/countries')
const airportTimezone = require('airport-timezone')
import xcurrency from '@/modules/api/currency'
import trackError from '@/modules/api/track-error'

export default {
  name: 'payment-summary',
  props: ['notop'],
  data () {
    return {
      submitBlocker: false,
      tmpAuthReturn: {
        leg1: [],
        leg2: []
      },
      tmpCommitBooking: '',
      tmpD2DNew: '',
      landTranspoQueue: [],
      tmpPickupData: {},
      tmpDropoffData: {},
      tmpBookingID: {
        leg1: {
          pickup: '',
          dropoff: ''
        },
        leg2: {
          pickup: '',
          dropoff: ''
        }
      },
      showBreakdown: true,
      captureTrxId: '',
      appRef: '',
      ground0: true,
      ground1: true,
      ground2: true,
      ground3: true,
      rsvpTotalIntl: {
        ground1: 0,
        ground2: 0,
        ground3: 0,
        ground4: 0
      },
      airlineReturnData: {
        firstD2dID: 0,
        active: 'leg1'
      },
      tmpCredits: 0,
      gozoCheck: false,
      gozoQueue: [],
      gozoIDs: {
        leg1: {
          pickup: '',
          dropoff: ''
        },
        leg2: {
          pickup: '',
          dropoff: ''
        }
      },
      flightIcon: "https://prod-opoli-web.s3.us-west-2.amazonaws.com/wordpress-assets/op/home/default-logo.png",
      groundFinalPriceTemp: {
        leg1: {
          pickup: 0,
          dropoff: 0
        },
        leg2: {
          pickup: 0,
          dropoff: 0
        }
      },
      dcPriceTemp: {
        leg1: {
          pickup: 0,
          dropoff: 0
        },
        leg2: {
          pickup: 0,
          dropoff: 0
        }
      }
    }
  },
  computed: {
    user () { return this.$store.state.user },
    booking () { return this.$store.state.booking },
    airlines () { return this.booking.airlines },
    locations () { return this.booking.locations },
    filters () { return this.booking.filters },
    isReturning () { return this.filters.departure.isReturning },
    selectedLeg1 () { return this.booking.selected.leg1 },
    selectedLeg2 () { return this.booking.selected.leg2 },
    selectedLeg2Flight () { return this.settings.customFlight ? this.selectedLeg2.flight : this.selectedLeg1.returnFlight },
    landQuote () { return this.booking.landQuote },
    landQuoteType () { return this.booking.landQuoteType },
    hideGround () { return this.booking.hideGround },
    _includedLandTranspo () { return this.booking.includedLandTranspo },
    groundLeg1Pickup () { return this.booking.selectedGround.leg1.pickup },
    groundLeg1Dropoff () { return this.booking.selectedGround.leg1.dropoff },
    groundLeg2Pickup () { return this.booking.selectedGround.leg2.pickup },
    groundLeg2Dropoff () { return this.booking.selectedGround.leg2.dropoff },

    landFeePickup () {
      if (this.other.widgetTab === 'flight') return 0

      // let selectedCabin = this.airlines.leg1.selectedCabin
      let leg1Depart = this.findService('leg1', 'pickup', this.groundLeg1Pickup)
      let landFee = leg1Depart.price
      landFee += leg1Depart.tip + leg1Depart.pickupFee + leg1Depart.airportFee + (leg1Depart.gasFee || 0) + leg1Depart.travelInsurance

      // if (leg1Depart.portalFee) {
      //   if (leg1Depart.portalFeeType === '$') landFee += leg1Depart.portalFee
      //   else landFee += parseFloat((landFee * (leg1Depart.portalFee / 100)).toFixed(2))
      // }
      if (landFee < 0) landFee = 0
      return landFee
    },
    landFeePickupReturn () {
      if (this.other.widgetTab === 'flight' || !this.isReturning) return 0

      // let selectedCabin = this.airlines.leg2.selectedCabin
      let leg2Depart = this.findService('leg2', 'pickup', this.groundLeg2Pickup)
      let landFee = leg2Depart.price
      landFee += leg2Depart.tip + leg2Depart.pickupFee + leg2Depart.airportFee + (leg2Depart.gasFee || 0) + leg2Depart.travelInsurance

      // if (leg2Depart.portalFee) {
      //   if (leg2Depart.portalFeeType === '$') landFee += leg2Depart.portalFee
      //   else landFee += parseFloat((landFee * (leg2Depart.portalFee / 100)).toFixed(2))
      // }
      if (landFee < 0) landFee = 0
      return landFee
    },
    landFeeDropoff () {
      if (this.other.widgetTab === 'flight') return 0

      // let selectedCabin = this.airlines.leg1.selectedCabin
      let leg1Arrive = this.findService('leg1', 'dropoff', this.groundLeg1Dropoff)
      let landFee = leg1Arrive.price
      landFee += leg1Arrive.tip + leg1Arrive.pickupFee + leg1Arrive.airportFee + (leg1Arrive.gasFee || 0) + leg1Arrive.travelInsurance

      // if (leg1Arrive.portalFee) {
      //   if (leg1Arrive.portalFeeType === '$') landFee += leg1Arrive.portalFee
      //   else landFee += parseFloat((landFee * (leg1Arrive.portalFee / 100)).toFixed(2))
      // }
      if (landFee < 0) landFee = 0
      return landFee
    },
    landFeeDropoffReturn () {
      if (this.other.widgetTab === 'flight' || !this.isReturning) return 0

      // let selectedCabin = this.airlines.leg1.selectedCabin
      let leg2Arrive = this.findService('leg2', 'dropoff', this.groundLeg2Dropoff)
      let landFee = leg2Arrive.price
      landFee += leg2Arrive.tip + leg2Arrive.pickupFee + leg2Arrive.airportFee + (leg2Arrive.gasFee || 0) + leg2Arrive.travelInsurance

      // if (leg2Arrive.portalFee) {
      //   if (leg2Arrive.portalFeeType === '$') landFee += leg2Arrive.portalFee
      //   else landFee += parseFloat((landFee * (leg2Arrive.portalFee / 100)).toFixed(2))
      // }
      if (landFee < 0) landFee = 0
      return landFee
    },

    landFeePickupOrig () {
      if (this.other.widgetTab === 'flight') return 0

      let leg1Depart = this.findService('leg1', 'pickup', this.groundLeg1Pickup)
      let landFee = leg1Depart.origPrice
      landFee += leg1Depart.tip + leg1Depart.pickupFee + leg1Depart.airportFee + (leg1Depart.gasFee || 0) + leg1Depart.travelInsurance

      // if (leg1Depart.portalFee) {
      //   if (leg1Depart.portalFeeType === '$') landFee += leg1Depart.portalFee
      //   else landFee += parseFloat((landFee * (leg1Depart.portalFee / 100)).toFixed(2))
      // }
      if (landFee < 0) landFee = 0
      return landFee
    },
    landFeePickupOrigReturn () {
      if (this.other.widgetTab === 'flight' || !this.isReturning) return 0

      // let selectedCabin = this.airlines.leg2.selectedCabin
      let landQuote = this.findService('leg2', 'pickup', this.groundLeg2Pickup)
      let landFee = landQuote.origPrice
      landFee += landQuote.tip + landQuote.pickupFee + landQuote.airportFee + (landQuote.gasFee || 0) + landQuote.travelInsurance

      // if (landQuote.portalFee) {
      //   if (landQuote.portalFeeType === '$') landFee += landQuote.portalFee
      //   else landFee += parseFloat((landFee * (landQuote.portalFee / 100)).toFixed(2))
      // }
      if (landFee < 0) landFee = 0
      return landFee
    },
    landFeeDropoffOrig () {
      if (this.other.widgetTab === 'flight') return 0

      // let selectedCabin = this.airlines.leg1.selectedCabin
      let leg1Arrive = this.findService('leg1', 'dropoff', this.groundLeg1Dropoff)
      let landFee = leg1Arrive.origPrice
      landFee += leg1Arrive.tip + leg1Arrive.pickupFee + leg1Arrive.airportFee + (leg1Arrive.gasFee || 0) + leg1Arrive.travelInsurance

      // if (leg1Arrive.portalFee) {
      //   if (leg1Arrive.portalFeeType === '$') landFee += leg1Arrive.portalFee
      //   else landFee += parseFloat((landFee * (leg1Arrive.portalFee / 100)).toFixed(2))
      // }
      if (landFee < 0) landFee = 0
      return landFee
    },
    landFeeDropoffOrigReturn () {
      if (this.other.widgetTab === 'flight' || !this.isReturning) return 0

      // let selectedCabin = this.airlines.leg2.selectedCabin
      let landQuote = this.findService('leg2', 'dropoff', this.groundLeg2Dropoff)
      let landFee = landQuote.origPrice
      landFee += landQuote.tip + landQuote.pickupFee + landQuote.airportFee + (landQuote.gasFee || 0) + landQuote.travelInsurance

      // if (landQuote.portalFee) {
      //   if (landQuote.portalFeeType === '$') landFee += landQuote.portalFee
      //   else landFee += parseFloat((landFee * (landQuote.portalFee / 100)).toFixed(2))
      // }
      if (landFee < 0) landFee = 0
      return landFee
    },

    landFeePickupDiscounted () {
      if (this.other.widgetTab === 'flight') return 0

      let landFee = this.landFeePickup
      if (this.leg1Discount.value > 0) {
        let dc = this.leg1Discount.value
        if (this.leg1Discount.currency === '%') dc = landFee * (this.leg1Discount.value / 100)
        landFee -= dc
      }
      if (parseFloat(landFee) < 0) landFee = 0
      return landFee
    },
    landFeeDropoffDiscounted () {
      if (this.other.widgetTab === 'flight') return 0

      let landFee = this.landFeeDropoff
      if (this.leg2Discount.value > 0) {
        let dc = this.leg2Discount.value
        if (this.leg2Discount.currency === '%') dc = landFee * (this.leg2Discount.value / 100)
        landFee -= dc
      }
      if (parseFloat(landFee) < 0) landFee = 0
      return landFee
    },
    landFeePickupReturnDiscounted () {
      if (this.other.widgetTab === 'flight' || !this.isReturning) return 0

      let landFee = this.landFeePickupReturn
      if (this.leg3Discount.value > 0) {
        let dc = this.leg3Discount.value
        if (this.leg3Discount.currency === '%') dc = landFee * (this.leg3Discount.value / 100)
        landFee -= dc
      }
      if (parseFloat(landFee) < 0) landFee = 0
      return landFee
    },
    landFeeDropoffReturnDiscounted () {
      if (this.other.widgetTab === 'flight' || !this.isReturning) return 0

      let landFee = this.landFeeDropoffReturn
      if (this.leg4Discount.value > 0) {
        let dc = this.leg4Discount.value
        if (this.leg4Discount.currency === '%') dc = landFee * (this.leg4Discount.value / 100)
        landFee -= dc
      }
      if (parseFloat(landFee) < 0) landFee = 0
      return landFee
    },

    baseFareWithMarkup () {
      let price = this.booking.selected.leg1.payment.breakdown.BasePrice || this.booking.selected.leg1.payment.breakdown.BasicFare
      price = price + (price * this.booking.settings.markUpPercent)
      return parseFloat(price.toFixed(2))
    },
    baseFareWithMarkupReturn () {
      if (!this.isReturning || !this.settings.customFlight) return 0
      let price = this.booking.selected.leg2.payment.breakdown.BasePrice || this.booking.selected.leg2.payment.breakdown.BasicFare
      price = price + (price * this.booking.settings.markUpPercent)
      return parseFloat(price.toFixed(2))
    },
    tax () {
      let tax = this.booking.selected.leg1.payment.breakdown.Tax
      tax = tax + (tax * this.booking.settings.markUpPercent)
      if (this.isReturning && this.settings.customFlight) {
        let tax2 = this.booking.selected.leg2.payment.breakdown.Tax
        tax2 = tax2 + (tax2 * this.booking.settings.markUpPercent)
        tax += tax2
      }
      return tax.toFixed(2)
    },
    getAirFare () {
      let fare = this.booking.selected.leg1.payment.totalWithMarkUp
      return parseFloat(fare.toFixed(2))
    },
    getAirFareReturn () {
      if (!this.isReturning || !this.settings.customFlight) return 0
      let fare = this.booking.selected.leg2.payment.totalWithMarkUp
      return parseFloat(fare.toFixed(2))
    },
    getTransportFee () {
      let landFee = 0
      if (this.booking.includedLandTranspo.indexOf(0) > -1 && !this.leg1Free) landFee = this.landFeePickupDiscounted
      if (this.booking.includedLandTranspo.indexOf(1) > -1 && !this.leg2Free) landFee += this.landFeeDropoffDiscounted
      if (this.isReturning) {
        if (this.booking.includedLandTranspo.indexOf(2) > -1 && !this.leg3Free) landFee += this.landFeePickupReturnDiscounted
        if (this.booking.includedLandTranspo.indexOf(3) > -1 && !this.leg4Free) landFee += this.landFeeDropoffReturnDiscounted
      }

      let total = this.getAirFare
      if (this.isReturning) total += parseFloat(this.getAirFareReturn)
      total += landFee
      return total.toFixed(2)
    },
    total () {
      let total = parseFloat(this.getTransportFee)
      if (this.credits && this.user.token) total = total - this.credits
      if (total <= 0) total = 1
      return total.toFixed(2)
    },
    showProceed () { return this.$route.name === 'D2DItinerary' },
    showProceed2 () { return ['D2DPaxForm', 'Payment', 'D2DReview'].indexOf(this.$route.name) > -1 },
    showBook () { return this.$route.name === 'D2DReview' },
    brandId () { return this.$store.state.brandId },
    selectedCard () { return this.$store.state.selectedCard },
    // locs () {
    //   let pickup = this.locations.pickup
    //   let dropoff = this.locations.dropoff
    //   return {
    //     pickup: pickup.title,
    //     pickupAirport: this.locations.pickupAirport.name,
    //     pickupAirportReturn: this.locations.pickupAirportReturn.name,
    //     dropoff: dropoff.title,
    //     dropoffAirport: this.locations.dropoffAirport.name,
    //     dropoffAirportReturn: this.locations.dropoffAirportReturn.name
    //   }
    // },
    credits () { return this.$store.state.credits },
    other () { return this.$store.state.other },
    currency () { return this.other.currency },
    totalDiscount () {
      return false
      // let totalDC = 0
      // let selectedCabin = this.airlines.leg1.selectedCabin
      // let leg1Depart = this.booking.landQuote.leg1Depart[selectedCabin]
      // let leg1Arrive = this.booking.landQuote.leg1Arrive[selectedCabin]
      // let selectedCabinReturn = this.isReturning ? this.airlines.leg2.selectedCabin : selectedCabin
      // let leg2Depart = this.booking.landQuote.leg2Depart[selectedCabinReturn]
      // let leg2Arrive = this.booking.landQuote.leg2Arrive[selectedCabinReturn]
      // if (this.booking.includedLandTranspo.indexOf(0) > -1 && !this.leg1Free) {
      //   let tmpDC = 0
      //   if (leg1Depart.discount && leg1Depart.origPrice !== leg1Depart.discount) {
      //     tmpDC = leg1Depart.origPrice - leg1Depart.discount > 0 ? leg1Depart.discount : leg1Depart.origPrice
      //   }
      //   totalDC = tmpDC
      // }
      // if (this.booking.includedLandTranspo.indexOf(1) > -1 && !this.leg2Free) {
      //   let tmpDC = 0
      //   if (leg1Arrive.discount && leg1Arrive.origPrice !== leg1Arrive.discount) {
      //     tmpDC = leg1Arrive.origPrice - leg1Arrive.discount > 0 ? leg1Arrive.discount : leg1Arrive.origPrice
      //   }
      //   totalDC += tmpDC
      // }
      // if (this.filters.departure.isReturning) {
      //   if (this.booking.includedLandTranspo.indexOf(2) > -1 && !this.leg3Free) {
      //     let tmpDC = 0
      //     if (leg2Depart.discount && leg2Depart.origPrice !== leg2Depart.discount) {
      //       tmpDC = leg2Depart.origPrice - leg2Depart.discount > 0 ? leg2Depart.discount : leg2Depart.origPrice
      //     }
      //     totalDC += tmpDC
      //   }
      //   if (this.booking.includedLandTranspo.indexOf(3) > -1 && !this.leg4Free) {
      //     let tmpDC = 0
      //     if (leg2Arrive.discount && leg2Arrive.origPrice !== leg2Arrive.discount) {
      //       tmpDC = leg2Arrive.origPrice - leg2Arrive.discount > 0 ? leg2Arrive.discount : leg2Arrive.origPrice
      //     }
      //     totalDC += tmpDC
      //   }
      // }
      // return totalDC
    },
    settings () { return this.booking.settings },
    leg1Discount () { return this.settings.groundLeg1 },
    leg2Discount () { return this.settings.groundLeg2 },
    leg3Discount () { return this.settings.groundLeg3 },
    leg4Discount () { return this.settings.groundLeg4 },
    leg1Free () { return this.leg1Discount.free },
    leg2Free () { return this.leg2Discount.free },
    leg3Free () { return this.leg3Discount.free },
    leg4Free () { return this.leg4Discount.free },
    totalLegsCount () {
      let x = 0
      if (this.booking.includedLandTranspo.indexOf(0) > -1 && !this.leg1Free) x++
      if (this.booking.includedLandTranspo.indexOf(1) > -1 && !this.leg2Free) x++
      if (this.booking.includedLandTranspo.indexOf(2) > -1 && !this.leg3Free) x++
      if (this.booking.includedLandTranspo.indexOf(3) > -1 && !this.leg4Free) x++
      return x
    },
    _route () { return this.$route.name },
    flightPrice () { return this.booking.flightPrice },
    brandLabel () {
      let brand = Object.values(CONFIG.Brands).find(x => x.id === this.$store.state.brandId)
      return brand ? brand.label : 'Door2Door'
    },
    savedTimezone () { return this.$store.state.reservation.timezones }
  },
  methods: {
    dateFormat (x) {
      if (!x) return ''
      return moment(x, 'YYYY-MM-DD HH:mm').format('ddd, MMM DD')
    },
    priceFormat (data, addSymbol = false) {
      let val = parseFloat(data).toLocaleString('en-US', {minimumFractionDigits: 2})
      if (addSymbol) {
        return data < 0 ? `-$ ${Math.abs(val).toFixed(2)}` : `$ ${val}`
      }
      return val
    },
    findService (leg, type, id) {
      // let categories = this.landQuote[`${leg}${type === 'pickup' ? 'Depart' : 'Arrive'}`].categorized
      // for (const category in categories) {
      //   const foundItem = categories[category].find(item => item.id === id)
      //   if (foundItem) return foundItem
      // }
      let landQuoteType = this.landQuoteType[`${leg}${type === 'pickup' ? 'Depart' : 'Arrive'}`]
      let landQuote = this.landQuote[`${leg}${type === 'pickup' ? 'Depart' : 'Arrive'}`]
      if (landQuoteType !== 'rsp') {
        let service = landQuote.list.find(x => x.id === id)
        if (service) return service
      } else {
        if (landQuote.Economy.id === id) return landQuote.Economy
        if (landQuote.PremiumEconomy.id === id) return landQuote.PremiumEconomy
        if (landQuote.Business.id === id) return landQuote.Business
        if (landQuote.First.id === id) return landQuote.First
        let service = landQuote.list.find(x => x.id === id)
        if (service) return service
      }
      return {
        name: '',
        img: '',
        price: 0,
        tip: 0,
        pickupFee: 0,
        airportFee: 0,
        travelInsurance: 0
      }
    },
    proceedToPax () {
      this.$router.push('review-summary')

      if (window.gtag) { // eslint-disable-line
        gtag('event', 'D2Ditinerary - Payment/Review') // eslint-disable-line
      }
    },
    initBook (isLeg2 = false) {
      let self = this

      if (self.submitBlocker) return
      self.submitBlocker = true

      let flightFee = parseFloat(self.getAirFare)
      let landFee = 0
      let credits = self.credits
      self.gozoCheck = false
      if (isLeg2) self.gozoCheck = true
      self.$store.commit('booking/setOthersData', {processingFlightSubmit: false})
      if (self.isReturning) {
        if (this.booking.includedLandTranspo.indexOf(0) > -1 && !isLeg2 && !self.leg1Free) landFee = this.landFeePickupDiscounted
        if (this.booking.includedLandTranspo.indexOf(1) > -1 && !isLeg2 && !self.leg2Free) landFee += this.landFeeDropoffDiscounted
        if (this.booking.includedLandTranspo.indexOf(2) > -1 && (isLeg2 || !self.settings.customFlight) && !self.leg3Free) landFee += this.landFeePickupReturnDiscounted
        if (this.booking.includedLandTranspo.indexOf(3) > -1 && (isLeg2 || !self.settings.customFlight) && !self.leg4Free) landFee += this.landFeeDropoffReturnDiscounted
        let tmpLeg = isLeg2 === true ? 'leg2' : 'leg1'
        if (!self.settings.customFlight) tmpLeg = 'leg1'
        flightFee = parseFloat(self.booking.selected[tmpLeg].payment.totalWithMarkUp)
        let totalPrice = landFee + flightFee
        if (!isLeg2) {
          self.airlineReturnData.active = 'leg1'
          self.tmpCredits = 0
          if (self.settings.customFlight) credits = credits / 2
          self.tmpCredits = credits
          if (self.tmpCredits > totalPrice) {
            credits = totalPrice
            self.tmpCredits = self.tmpCredits + (self.tmpCredits - totalPrice)
          }
        } else {
          credits = self.tmpCredits
          if (self.tmpCredits > totalPrice) credits = totalPrice
        }
      } else {
        if (this.booking.includedLandTranspo.indexOf(0) > -1 && !this.leg1Free) landFee = this.landFeePickupDiscounted
        if (this.booking.includedLandTranspo.indexOf(1) > -1 && !this.leg2Free) landFee += this.landFeeDropoffDiscounted
      }

      self.$store.commit('other/setOtherData', {
        appLoader: true,
        appLoaderMsg: 'Processing. Please wait...'
      })
      self.$store.commit('booking/setOthersData', {processingFlightSubmit: true})

      let pax = []
      let paxType = ['adult', 'children', 'infants']
      paxType.forEach(pt => {
        self.filters.travellers.info[pt].forEach((p, i) => {
          if (Array.isArray(p)) p = p[0]
          let countryPhoneCode = p[`countryCode${i}`] || ''
          if (countryPhoneCode && countryPhoneCode.toString().indexOf('+') > -1) {
            countryPhoneCode = parseInt(countryPhoneCode.toString().substring(1))
          }
          pax.push({
            email: p[`email${i}`],
            phone: `${countryPhoneCode}${p[`mobile${i}`]}`,
            middleName: p[`middleName${i}`],
            suffix: p[`suffix${i}`]
          })
        })
      })
      let param = {
        token: self.$store.state.user.token,
        cardId: self.selectedCard.id,
        fare: {
          markup: self.booking.settings.markUpPercent,
          flight: parseFloat(flightFee),
          rsvp: parseFloat(landFee.toFixed(2)),
          currency: 'usd',
          credits: credits
        },
        price: self.booking.finalPrice.leg1,
        guest: pax[0]
      }
      if (!param.guest.phone.includes('+')) {
        param.guest.phone = `+${param.guest.phone}`
      }
      if (self.currency.code !== 'USD') {
        param.currency = {
          flight: self.applyCurrency(param.fare.flight, false),
          rsvp: self.applyCurrency(param.fare.rsvp, false),
          currency: self.currency.code,
          credits: self.applyCurrency(param.fare.credits, false)
        }
      }
      if (self.isReturning && isLeg2 && self.settings.customFlight) {
        param.price = self.booking.finalPrice.leg2
        param.bundledId = self.tmpD2DNew[0]
      }

      let tmpGtag = {}
      tmpGtag[`auth${isLeg2 ? 2 : 1}`] = param
      self.$store.commit('gtag/setGtagData', tmpGtag)

      self.$sdk.post2(`${CONFIG.d2dGateway}/d2d/auth`, param, r => {
        try {
          if (r.error) {
            self.$store.commit('other/setOtherData', {appLoader: false, appLoaderMsg: ''})

            let response = r
            let msg = r.error.message
            if (r.error.response && r.error.response.data) {
              response = r.error.response.data
              if (response.error.message) msg = response.error.message
            }
            self.$store.commit('global/setAlertData', {show: true, message: msg})
            self.$store.commit('booking/setOthersData', {processingFlightSubmit: false})
            trackError.track(self, {
              type: 'd2d/auth',
              data: {
                request: {
                  url: `${CONFIG.d2dGateway}/d2d/auth`,
                  payload: param
                },
                response: response
              }
            })
            self.submitBlocker = false
            return
          }
          self.tmpAuthReturn[isLeg2 ? 'leg2' : 'leg1'] = r.d2dId
          self.tmpD2DNew = r.d2dId
          if (self.isReturning && self.booking.activeLeg === 'leg1') {
            self.airlineReturnData.firstD2dID = r.d2dId
          }

          // self.beginLandTranspo()
          self.book(isLeg2 ? 'leg2' : 'leg1')
        } catch (error) {
          self.$store.commit('other/setOtherData', {appLoader: false, appLoaderMsg: ''})
          self.$store.commit('global/setAlertData', {show: true, message: error})
          self.$store.commit('booking/setOthersData', {processingFlightSubmit: false})
          trackError.track(self, {
            type: 'd2d/auth',
            data: {
              request: {
                url: `${CONFIG.d2dGateway}/d2d/auth`,
                payload: param
              },
              response: '',
              console_error: error
            }
          })
          self.submitBlocker = false
        }
      })
    },
    book (leg) {
      let self = this
      // if (!self.gozoCheck && self.other.widgetTab === 'd2d' &&
      //   (self.locations.pickup.country === 'IND' || self.locations.dropoff.country === 'IND')
      // ) {
      //   self.processGroundGozocabs()
      //   return
      // }

      self.appRef = self.buildAppReference()
      let pax = []
      let paxType = ['adult', 'children', 'infants']
      paxType.forEach(pt => {
        self.filters.travellers.info[pt].forEach((p, i) => {
          if (Array.isArray(p)) p = p[0]
          let PaxType = 1
          if (pt === 'children') PaxType = 2
          if (pt === 'infants') PaxType = 3
          let countryPhoneCode = p[`countryCode${i}`] || ''
          if (countryPhoneCode && countryPhoneCode.toString().indexOf('+') > -1) {
            countryPhoneCode = parseInt(countryPhoneCode.toString().substring(1))
          }
          let ContactNo = self.sanitizeInput(`${countryPhoneCode}${p[`mobile${i}`]}`)
          let paxObj = {
            IsLeadPax: 0,
            Title: p[`title${i}`],
            FirstName: p[`firstName${i}`],
            LastName: p[`lastName${i}`],
            Gender: parseInt(p[`gender${i}`]),
            DateOfBirth: p[`bday${i}`],
            PassportNumber: p[`passport${i}`],
            CountryCode: countries[p[`country${i}`].toLowerCase()].code ? countries[p[`country${i}`].toLowerCase()].code.toUpperCase() : '',
            CountryName: countries[p[`country${i}`].toLowerCase()].code ? countries[p[`country${i}`].toLowerCase()].name : '',
            ContactNo: ContactNo,
            City: p[`city${i}`],
            PinCode: p[`zip${i}`],
            AddressLine1: p[`address${i}`],
            Email: p[`email${i}`],
            PaxType: PaxType,
            MiddleName: p[`middleName${i}`],
            Suffix: p[`suffix${i}`]
          }
          let adult0 = self.filters.travellers.info.adult[0]
          if (!paxObj.City && adult0 && adult0.city0) {
            paxObj.City = adult0.city0
            paxObj.PinCode = adult0.zip0
            paxObj.AddressLine1 = adult0.address0
          }
          pax.push(paxObj)
        })
      })
      pax[0].IsLeadPax = 1

      self.$store.commit('other/setOtherData', {
        appLoader: true,
        appLoaderMsg: 'Booking your flight. Please wait...'
      })

      self.$store.commit('booking/setOthersData', {flightPending: false})
      let lastToken = self.booking.lastToken[leg]
      let param = {
        AppReference: self.appRef,
        SequenceNumber: '0',
        ResultToken: lastToken,
        Passengers: pax
      }
      self.$sdk.post2(`${CONFIG.d2dAPI}/flight/commit-booking`, param, r => {
        try {
          if (!Object.keys(r).length) {
            self.$store.commit('other/setOtherData', {appLoader: false, appLoaderMsg: ''})
            self.$store.commit('global/setAlertData', {show: true, message: 'Something went wrong. Please try again later.'})
            self.$store.commit('booking/setOthersData', {processingFlightSubmit: false})
            trackError.track(self, {
              type: 'commit-booking',
              data: {
                request: {
                  url: `${CONFIG.d2dAPI}/flight/commit-booking`,
                  payload: param,
                  checker: 1
                },
                response: r
              }
            })
            self.submitBlocker = false
            return
          }
          if (!r.Status) {
            self.$store.commit('other/setOtherData', {appLoader: false, appLoaderMsg: ''})
            self.$store.commit('global/setAlertData', {show: true, message: r.Message})
            self.$store.commit('booking/setOthersData', {processingFlightSubmit: false})
            trackError.track(self, {
              type: 'commit-booking',
              data: {
                request: {
                  url: `${CONFIG.d2dAPI}/flight/commit-booking`,
                  payload: param,
                  checker: 2
                },
                response: r
              }
            })
            self.submitBlocker = false
            return
          }
          if (r.data && r.data.Status === 0) {
            self.$store.commit('other/setOtherData', {appLoader: false, appLoaderMsg: ''})
            self.$store.commit('global/setAlertData', {
              show: true,
              message: `Your Booking has failed, please try again later. ${r.data.Message}.`,
              action: 'redirectToHome'
            })
            self.$store.commit('booking/setOthersData', {processingFlightSubmit: false})
            trackError.track(self, {
              type: 'commit-booking',
              data: {
                request: {
                  url: `${CONFIG.d2dAPI}/flight/commit-booking`,
                  payload: param,
                  checker: 3
                },
                response: r
              }
            })
            self.submitBlocker = false
            return
          }
          if ([2, 7].indexOf(r.Status) > -1) {
            self.$store.commit('booking/setOthersData', {flightPending: true})
          }
          self.tmpCommitBooking = r
          self.d2dCapture(leg)
          // self.beginLandTranspo()
        } catch (error) {
          self.$store.commit('other/setOtherData', {appLoader: false, appLoaderMsg: ''})
          self.$store.commit('global/setAlertData', {show: true, message: 'Something went wrong. Please try again.'})
          self.$store.commit('booking/setOthersData', {processingFlightSubmit: false})
          trackError.track(self, {
            type: 'commit-booking',
            data: {
              request: {
                url: `${CONFIG.d2dAPI}/flight/commit-booking`,
                payload: param,
                checker: 4
              },
              response: '',
              console_error: error
            }
          })
          self.submitBlocker = false
        }
      })
    },
    beginLandTranspo (leg) {
      this.landTranspoQueue = []
      if (this.other.widgetTab === 'd2d') {
        if (this.booking.includedLandTranspo.indexOf(0) > -1 && leg === 'leg1') {
          this.landTranspoQueue.push(['submitPickup', 'leg1'])
        }
        if (this.booking.includedLandTranspo.indexOf(1) > -1 && leg === 'leg1') {
          this.landTranspoQueue.push(['submitDropoff', 'leg1'])
        }
        // if (this.booking.includedLandTranspo.indexOf(2) > -1 && (leg === 'leg2' || (this.isReturning && !this.settings.customFlight))) {
        if (this.booking.includedLandTranspo.indexOf(2) > -1 && leg === 'leg2') {
          this.landTranspoQueue.push(['submitPickup', 'leg2'])
        }
        // if (this.booking.includedLandTranspo.indexOf(3) > -1 && (leg === 'leg2' || (this.isReturning && !this.settings.customFlight))) {
        if (this.booking.includedLandTranspo.indexOf(3) > -1 && leg === 'leg2') {
          this.landTranspoQueue.push(['submitDropoff', 'leg2'])
        }
      }
      this.processLandTranspo(leg)
    },
    processLandTranspo (leg) {
      if (!this.landTranspoQueue.length) {
        this.d2dAttach(leg)
        // if (this.isReturning) {
        //   this.d2dAttach(this.booking.activeLeg)
        // } else {
        //   this.d2dAttach('leg1')
        // }
        return
      }
      if (this.landTranspoQueue[0] && this.landTranspoQueue[0][0] === 'submitPickup') {
        // this.submitRsvp('pickup', this.landTranspoQueue[0][1])
        // get timezone first before submitting pickup RSVP
        this.getTimezone('pickup', this.landTranspoQueue[0][1])
        return
      }
      if (this.landTranspoQueue[0] && this.landTranspoQueue[0][0] === 'submitDropoff') {
        // this.submitRsvp('dropoff', this.landTranspoQueue[0][1])
        // get timezone first before submitting dropoff RSVP
        this.getTimezone('dropoff', this.landTranspoQueue[0][1])
        return
      }
      this.d2dAttach('leg1')
    },
    submitRsvp (type, leg) {
      let self = this
      let rsvpData = self.buildRsvp(type, leg)
      rsvpData.d2dId = self.tmpAuthReturn[leg][0]
      if (!self.settings.customFlight) rsvpData.d2dId = self.tmpD2DNew[leg === 'leg1' ? 0 : 1]
      // if (self.isReturning) {
      //   rsvpData.d2dId = self.tmpD2DNew[0]
      // } else {
      //   rsvpData.d2dId = leg === 'leg1' ? self.tmpD2DNew[0] : self.tmpD2DNew[1]
      // }
      if (rsvpData.legs[0].currency) {
        let field = type === 'pickup' ? 'ground1' : 'ground2'
        if (leg === 'leg2') {
          field = type === 'pickup' ? 'ground3' : 'ground4'
        }
        let rsvpCurrency = rsvpData.legs[0].currency
        let rsvpCurAmount = rsvpCurrency.DCamount || 0
        self.rsvpTotalIntl[field] = rsvpCurAmount
        // self.rsvpTotalIntl[field] = rsvpCurAmount + rsvpCurrency.tipAmount + rsvpCurrency.pickupFee + rsvpCurrency.airportFee + (rsvpCurrency.gasFee || 0) + rsvpCurrency.travelInsurance
      }
      // rsvpData.d2dId = 1
      self.$sdk.post(self, '/reservations', rsvpData, r => {
        if (!r.error) {
          self.tmpBookingID[leg][type] = r.reservationId[0]
          self.landTranspoQueue.shift()
          self.processLandTranspo(leg)
        } else {
          self.$store.commit('other/setOtherData', {appLoader: false, appLoaderMsg: ''})
          self.$store.commit('global/setAlertData', {show: true, message: r.error.message})
          self.$store.commit('booking/setOthersData', {processingFlightSubmit: false})
          trackError.track(self, {
            type: 'rsvp-submit',
            data: {
              request: {
                route: '/reservations',
                payload: rsvpData
              },
              response: r
            }
          })
          self.submitBlocker = false
          return
        }
      }, '1.1')
    },
    buildRsvp (type, leg) {
      let self = this
      let leg1 = this.buildLeg(type, leg)
      let totalFare = 0
      if (type === 'pickup') {
        // if (leg === 'leg1') totalFare = !this.leg1Free ? this.landFeePickup : 0
        // else totalFare = !this.leg3Free ? this.landFeePickupReturn : 0
        if (leg === 'leg1') totalFare = this.landFeePickup
        else totalFare = this.landFeePickupReturn
      } else {
        // if (leg === 'leg1') totalFare = !this.leg2Free ? this.landFeeDropoff : 0
        // else totalFare = !this.leg4Free ? this.landFeeDropoffReturn : 0
        if (leg === 'leg1') totalFare = this.landFeeDropoff
        else totalFare = this.landFeeDropoffReturn
      }

      let landQuoteType = this.booking.landQuoteType
      let quoteType = type === 'pickup' ? 'Depart' : 'Arrive'
      let isLyft = landQuoteType[`${leg}${quoteType}`] === 'lyft'

      totalFare = totalFare.toFixed(2)
      let guest = null
      let travellers = this.filters.travellers
      if (travellers.forSomeoneElse) {
        let pax = travellers.info.adult[0]
        if (!travellers.info.adult.length && travellers.info.children.length) {
          pax = travellers.info.children[0]
        }
        if (!travellers.info.adult.length && !travellers.info.children.length) {
          pax = travellers.info.infants[0]
        }
        guest = {
          firstName: `${pax.firstName0} ${pax.middleName0}`,
          lastName: `${pax.lastName0} ${pax.suffix0}`,
          mobile: `${pax.countryCode0}${pax.mobile0}`
        }
        guest.firstName = guest.firstName.trim()
        guest.lastName = guest.lastName.trim()
        if (!guest.mobile.includes('+')) {
          guest.mobile = `+${guest.mobile}`
        }
      }

      let d2dDiscount = 0
      let hasDc = false
      let dcField = ''
      if (leg === 'leg1') {
        if (type === 'pickup' && this.leg1Discount.value > 0) {
          hasDc = true
          dcField = 'leg1Discount'
        }
        if (type === 'dropoff' && this.leg2Discount.value > 0) {
          hasDc = true
          dcField = 'leg2Discount'
        }
      } else {
        if (type === 'pickup' && this.leg3Discount.value > 0) {
          hasDc = true
          dcField = 'leg3Discount'
        }
        if (type === 'dropoff' && this.leg4Discount.value > 0) {
          hasDc = true
          dcField = 'leg4Discount'
        }
      }
      if (hasDc) {
        d2dDiscount = this[dcField].value
        if (this[dcField].currency === '%') d2dDiscount = totalFare * (this[dcField].value / 100)
      }

      self.groundFinalPriceTemp[leg][type] = totalFare

      let tmp = {
        token: this.user.token,
        brandId: this.brandId,
        deviceType: 'ww',
        source: 'C',
        guest: guest,
        legs: [leg1, null],
        payment: {
          cardID: this.selectedCard.id,
          tip: leg1.tip || 0,
          total: totalFare,
          fare: totalFare,
          pickupFee: 0, // TODO
          promo: 0
        },
        wheelChair: 0,
        serviceDog: 0,
        hudson: false
      }
      if (isLyft) tmp.lyft = true
      if (d2dDiscount) {
        tmp.payment.d2dDiscount = d2dDiscount
      }
      this.dcPriceTemp[leg][type] = tmp.payment.d2dDiscount || 0
      // if ((type === 'pickup' && leg1.pickup.country === 'IND') ||
      //   (type === 'dropoff' && leg1.dropoff.country === 'IND')
      // ) {
      //   tmp.isGozoCabs = true
      // }

      return tmp
    },
    buildLeg (type, leg) {
      let self = this
      let pickup = '' // leg1Data.pickup
      let dropoff = '' // leg1Data.dropoff
      let landQuote = ''
      let departData = this.booking.landQuote.leg1Depart
      let arriveData = this.booking.landQuote.leg1Arrive
      let pickupTime = ''
      let amount = 0
      let origPrice = 0
      let airportFee = 0
      let gasFee = 0
      let pickupFee = 0
      let tip = 0
      let travelInsurance = 0
      let tmpLeg = self.settings.customFlight ? leg : 'leg1'
      let selectedCabin = this.airlines[tmpLeg].selectedCabin
      let landQuoteType = this.landQuoteType[`${leg}${type === 'pickup' ? 'Depart' : 'Arrive'}`]
      let selectedService = null
      if (selectedCabin === 'API2') {
        let cabins = self.booking.cabinList
        let selectedGround = 'ground'
        selectedGround += leg === 'leg1' ? 'Leg1' : 'Leg2'
        selectedGround += type === 'pickup' ? 'Pickup' : 'Dropoff'
        if (landQuoteType !== 'rsp') {
          let service = self.landQuote[`${leg}${type === 'pickup' ? 'Depart' : 'Arrive'}`].list.find(x => x.id === self[selectedGround])
          if (service) selectedService = service
        } else {
          cabins.forEach(cabin => {
            if (self.landQuote[`${leg}${type === 'pickup' ? 'Depart' : 'Arrive'}`][cabin].id === self[selectedGround]) {
              selectedCabin = cabin
            }
          })
        }
      }
      let flightName = ''
      let flightNo = ''
      let dropoffFlightName = ''
      let dropoffFlightNo = ''
      let serviceId = 0

      if (type === 'pickup') {
        pickup = leg === 'leg1' ? this.locations.pickup : this.locations.dropoff
        dropoff = leg === 'leg1' ? this.locations.pickupAirport : this.locations.dropoffAirport
        landQuote = leg === 'leg1' ? this.booking.landQuote.leg1Depart : this.booking.landQuote.leg2Depart
        let tz = this.locations.pickupDetails.timezone[leg]
        if (!tz) {
          let code = leg === 'leg1' ? this.locations.pickupAirport.code : this.locations.dropoffAirport.code
          let tzIndex = airportTimezone.find(x => x.code === code)
          if (tzIndex) tz = tzIndex.timezone
        }
        pickupTime = moment.tz(this.locations.pickupDetails.pickupTime[leg], 'MM/DD/YYYY hh:mmA', tz)
        pickupTime = pickupTime.format('X')

        if (leg === 'leg2') departData = this.booking.landQuote.leg2Depart
        if (leg === 'leg2' && this.booking.gozoCabs.leg2Depart) {
          departData = this.booking.landQuote.leg2Depart
          landQuote = this.booking.landQuote.leg2Depart
        }
        if (landQuoteType === 'rsp') selectedService = departData[selectedCabin]
        amount = selectedService.price
        origPrice = selectedService.origPrice
        airportFee = selectedService.airportFee
        gasFee = selectedService.gasFee
        pickupFee = selectedService.pickupFee
        tip = selectedService.tip
        travelInsurance = selectedService.travelInsurance
        serviceId = selectedService.id
        if (leg === 'leg1') {
          flightName = ''
          flightNo = ''
          dropoffFlightName = this.selectedLeg1.flight[0].airline.name
          dropoffFlightNo = this.selectedLeg1.flight[0].flightNo
        } else {
          flightName = ''
          flightNo = ''
          dropoffFlightName = this.selectedLeg2Flight[0].airline.name
          dropoffFlightNo = this.selectedLeg2Flight[0].flightNo
        }
      }
      if (type === 'dropoff') {
        pickup = leg === 'leg1' ? this.locations.dropoffAirport : this.locations.pickupAirport
        dropoff = leg === 'leg1' ? this.locations.dropoff : this.locations.pickup
        landQuote = leg === 'leg1' ? this.booking.landQuote.leg1Arrive : this.booking.landQuote.leg2Arrive
        let tz = this.locations.dropoffDetails.timezone[leg]
        if (!tz) {
          let code = leg === 'leg1' ? this.locations.dropoffAirport.code : this.locations.pickupAirport.code
          let tzIndex = airportTimezone.find(x => x.code === code)
          if (tzIndex) tz = tzIndex.timezone
        }
        pickupTime = moment.tz(this.locations.dropoffDetails.pickupTime[leg], 'MM/DD/YYYY hh:mmA', tz)
        pickupTime = pickupTime.format('X')

        if (leg === 'leg2') arriveData = this.booking.landQuote.leg2Arrive
        if (leg === 'leg2' && this.booking.gozoCabs.leg2Arrive) {
          arriveData = this.booking.landQuote.leg2Arrive
          landQuote = this.booking.landQuote.leg2Arrive
        }
        if (landQuoteType === 'rsp') selectedService = arriveData[selectedCabin]
        amount = selectedService.price
        if (parseFloat(amount) < 0) amount = 0
        origPrice = selectedService.origPrice
        airportFee = selectedService.airportFee
        gasFee = selectedService.gasFee
        pickupFee = selectedService.pickupFee
        tip = selectedService.tip
        travelInsurance = selectedService.travelInsurance
        serviceId = selectedService.id
        if (leg === 'leg1') {
          flightName = this.selectedLeg1.flight[this.selectedLeg1.flight.length - 1].airline.name
          flightNo = this.selectedLeg1.flight[this.selectedLeg1.flight.length - 1].flightNo
          dropoffFlightName = ''
          dropoffFlightNo = ''
        } else {
          flightName = this.selectedLeg2Flight[this.selectedLeg2Flight.length - 1].airline.name
          flightNo = this.selectedLeg2Flight[this.selectedLeg2Flight.length - 1].flightNo
          dropoffFlightName = ''
          dropoffFlightNo = ''
        }
      }
      let rsvpData = {
        pickup: {
          address1: pickup.address1,
          address2: pickup.address2,
          city: pickup.city,
          state: pickup.state,
          zip: pickup.zip,
          lat: pickup.lat,
          lng: pickup.lng,
          title: pickup.title,
          geofenceId: leg === 'leg1' ? landQuote.pickupGeofence : landQuote.dropoffGeofence,
          country: pickup.country
        },
        dropoff: {
          address1: dropoff.address1,
          address2: dropoff.address2,
          city: dropoff.city,
          state: dropoff.state,
          zip: dropoff.zip,
          lat: dropoff.lat,
          lng: dropoff.lng,
          title: dropoff.title,
          geofenceId: leg === 'leg1' ? landQuote.dropoffGeofence : landQuote.pickupGeofence,
          country: dropoff.country
        },
        pickupTime: pickupTime,
        passengers: this.filters.travellers.total,
        luggage: this.filters.travellers.total * 2,
        amount: amount,
        originalPrice: origPrice,
        airportFee: airportFee,
        gasFee: gasFee,
        tip: tip,
        travelInsurance: travelInsurance,
        flightNumber: flightNo,
        flightName: flightName,
        dropoffFlightName: dropoffFlightName,
        dropoffFlightNumber: dropoffFlightNo,
        asap: false,
        etaInSec: landQuote.eta * 60,
        serviceTypeId: serviceId,
        pickupType: 'MeetAndGreet', // TODO
        pickupFee: pickupFee,
        distance: landQuote.distance,
        notes: ''
      }

      let pickupData = rsvpData.pickup
      let tzData = this.savedTimezone.find(x => parseFloat(x.lat) === parseFloat(pickupData.lat) && parseFloat(x.lng) === parseFloat(pickupData.lng))
      if (tzData) {
        rsvpData.pickupTimezone = tzData.timezone
      }

      let quoteType = type === 'pickup' ? 'Depart' : 'Arrive'
      let isLyft = this.landQuoteType[`${leg}${quoteType}`] === 'lyft'
      if (isLyft) {
        rsvpData.lyft = {
          ride_type: selectedService.ride_type,
          cost_token: selectedService.cost_token,
          driver_availability_token: selectedService.driver_availability_token || ''
        }
      }

      // enable only if gozocabs is back
      // if (
      //   (type === 'pickup' && pickup.country === 'IND') || (type === 'dropoff' && dropoff.country === 'IND')
      // ) {
      //   // let tmpLandQuote = type === 'pickup' ? this.booking.landQuote[`${leg}Depart`] : this.booking.landQuote[`${leg}Arrive`]
      //   // rsvpData.gozocabs = {
      //   //   cab: tmpLandQuote[selectedCabin].raw.cab,
      //   //   fare: tmpLandQuote[selectedCabin].raw.fare,
      //   //   distance: tmpLandQuote[selectedCabin].distance,
      //   //   cancellationPolicy: tmpLandQuote[selectedCabin].cancellationPolicy
      //   // }
      //   rsvpData.serviceTypeId = null
      // }

      // if (
      //   (type === 'pickup' && leg === 'leg1' && this.leg1Free) ||
      //   (type === 'dropoff' && leg === 'leg1' && this.leg2Free) ||
      //   (type === 'pickup' && leg === 'leg2' && this.leg3Free) ||
      //   (type === 'dropoff' && leg === 'leg2' && this.leg4Free)
      // ) {
      //   rsvpData.amount = 0
      //   rsvpData.tip = 0
      //   rsvpData.airportFee = 0
      //   airportFee = 0
      //   rsvpData.gasFee = 0
      //   gasFee = 0
      //   rsvpData.travelInsurance = 0
      //   travelInsurance = 0
      // }

      if (self.currency.code !== 'USD') {
        let DCamount = rsvpData.amount + rsvpData.tip + rsvpData.airportFee + rsvpData.gasFee + rsvpData.travelInsurance + rsvpData.pickupFee
        let groundLeg = 'groundLeg1'
        if (leg === 'leg1' && type === 'dropoff') groundLeg = 'groundLeg2'
        if (leg === 'leg2' && type === 'pickup') groundLeg = 'groundLeg3'
        if (leg === 'leg2' && type === 'dropoff') groundLeg = 'groundLeg4'
        if (self.settings[groundLeg].value) {
          if (self.settings[groundLeg].currency === '$') DCamount = DCamount - self.settings[groundLeg].value
          else {
            DCamount = DCamount - (DCamount * (self.settings[groundLeg].value / 100))
          }
          if (DCamount < 0) DCamount = 0
        }

        rsvpData.currency = {
          code: this.currency.code,
          exchangeRate: this.currency.value,
          amount: this.applyCurrency(rsvpData.amount, false),
          DCamount: this.applyCurrency(DCamount, false),
          tipAmount: this.applyCurrency(rsvpData.tip, false),
          pickupFee: 0,
          airportFee: this.applyCurrency(airportFee, false),
          gasFee: this.applyCurrency(gasFee, false),
          travelInsurance: this.applyCurrency(travelInsurance, false)
        }
        if (this.currency.code === 'JPY') {
          rsvpData.currency.amount = parseFloat(xcurrency.format({code: 'JPY', val: rsvpData.currency.amount}, false).replaceAll(',', ''))
          rsvpData.currency.DCamount = parseFloat(xcurrency.format({code: 'JPY', val: rsvpData.currency.DCamount}, false).replaceAll(',', ''))
          rsvpData.currency.tipAmount = parseFloat(xcurrency.format({code: 'JPY', val: rsvpData.currency.tipAmount}, false).replaceAll(',', ''))
          rsvpData.currency.pickupFee = parseFloat(xcurrency.format({code: 'JPY', val: rsvpData.currency.pickupFee}, false).replaceAll(',', ''))
          rsvpData.currency.airportFee = parseFloat(xcurrency.format({code: 'JPY', val: rsvpData.currency.airportFee}, false).replaceAll(',', ''))
          rsvpData.currency.gasFee = parseFloat(xcurrency.format({code: 'JPY', val: rsvpData.currency.gasFee}, false).replaceAll(',', ''))
          rsvpData.currency.travelInsurance = parseFloat(xcurrency.format({code: 'JPY', val: rsvpData.currency.travelInsurance}, false).replaceAll(',', ''))
        }
      }
      return rsvpData
    },
    d2dCapture (leg) {
      let self = this
      let params = {
        token: self.$store.state.user.token,
        d2dId: self.tmpAuthReturn[leg][0],
        commit: self.tmpCommitBooking,
        appReference: self.appRef
      }
      if (!self.settings.customFlight) params.d2dId = self.tmpD2DNew[leg === 'leg1' ? 0 : 1]
      self.$sdk.post2(`${CONFIG.d2dGateway}/d2d/capture`, params, r => {
        try {
          if (r.error) {
            self.$store.commit('other/setOtherData', {appLoader: false, appLoaderMsg: ''})
            self.$store.commit('global/setAlertData', {show: true, message: r.error.message})
            self.$store.commit('booking/setOthersData', {processingFlightSubmit: false})
            trackError.track(self, {
              type: 'd2d/capture',
              data: {
                request: {
                  url: `${CONFIG.d2dGateway}/d2d/capture`,
                  payload: params
                },
                response: r
              }
            })
            self.submitBlocker = false
            return
          }
          // self.captureTrxId = r.captureTrxId
          self.beginLandTranspo(leg)
          // if (self.isReturning) {
          //   self.d2dAttach(self.booking.activeLeg)
          // } else {
          //   self.d2dAttach('leg1')
          // }
        } catch (error) {
          self.$store.commit('other/setOtherData', {appLoader: false, appLoaderMsg: ''})
          self.$store.commit('global/setAlertData', {show: true, message: 'Something went wrong. Please try again.'})
          self.$store.commit('booking/setOthersData', {processingFlightSubmit: false})
          trackError.track(self, {
            type: 'd2d/capture',
            data: {
              request: {
                url: `${CONFIG.d2dGateway}/d2d/capture`,
                payload: params
              },
              response: '',
              console_error: error
            }
          })
          self.submitBlocker = false
        }
      })
    },
    d2dAttach (leg) {
      let self = this
      let tmpLeg = self.settings.customFlight ? leg : 'leg1'
      let params = {
        token: self.$store.state.user.token,
        d2dId: self.tmpAuthReturn[tmpLeg][0],
        rsvpId1: null,
        rsvpId2: null,
        rsvp1Fare: null,
        rsvp2Fare: null,
        // rsvp1Gozo: null,
        // rsvp2Gozo: null,
        email: true,
        send: true,
        sms: true
      }
      if (!self.settings.customFlight) params.d2dId = self.tmpD2DNew[leg === 'leg1' ? 0 : 1]
      // let pickup = self.locations.pickup
      // let dropoff = self.locations.dropoff
      if (leg === 'leg1') {
        // if (self.isReturning) {
        //   params.email = false
        //   params.send = false
        //   params.sms = false
        // }
        if (self.booking.includedLandTranspo.indexOf(0) > -1) {
          params.rsvpId1 = self.tmpBookingID[leg].pickup
          // params.rsvp1Fare = self.leg1Free ? 0 : self.landFeePickupDiscounted
          params.rsvp1Fare = self.leg1Free ? 0 : self.groundFinalPriceTemp[leg].pickup
          if (self.settings.groundLeg1.value) {
            if (self.settings.groundLeg1.currency === '$') {
              params.rsvp1Fare = params.rsvp1Fare - self.settings.groundLeg1.value
            } else {
              params.rsvp1Fare = params.rsvp1Fare - (params.rsvp1Fare * (self.settings.groundLeg1.value / 100))
            }
          }
          if (params.rsvp1Fare < 0) params.rsvp1Fare = 0
        }
        if (self.booking.includedLandTranspo.indexOf(1) > -1) {
          params.rsvpId2 = self.tmpBookingID[leg].dropoff
          // params.rsvp2Fare = self.leg2Free ? 0 : self.landFeeDropoffDiscounted
          params.rsvp2Fare = self.leg2Free ? 0 : self.groundFinalPriceTemp[leg].dropoff
          if (self.settings.groundLeg2.value) {
            if (self.settings.groundLeg2.currency === '$') {
              params.rsvp2Fare = params.rsvp2Fare - self.settings.groundLeg2.value
            } else {
              params.rsvp2Fare = params.rsvp2Fare - (params.rsvp2Fare * (self.settings.groundLeg2.value / 100))
            }
          }
          if (params.rsvp2Fare < 0) params.rsvp2Fare = 0
        }
        // if (pickup.country === 'IND' && self.booking.gozoCabs.leg1Depart) params.rsvp1Gozo = self.gozoIDs.leg1.pickup
        // if (dropoff.country === 'IND' && self.booking.gozoCabs.leg1Arrive) params.rsvp2Gozo = self.gozoIDs.leg1.dropoff
      }
      if (leg === 'leg2') {
        // params.d2dId = self.tmpD2DNew[self.isReturning ? 0 : 1]
        if (self.booking.includedLandTranspo.indexOf(2) > -1) {
          params.rsvpId1 = self.tmpBookingID[leg].pickup
          // params.rsvp1Fare = self.leg3Free ? 0 : self.landFeePickupReturnDiscounted
          params.rsvp1Fare = self.leg3Free ? 0 : self.groundFinalPriceTemp[leg].pickup
          if (self.settings.groundLeg3.value) {
            if (self.settings.groundLeg3.currency === '$') {
              params.rsvp1Fare = params.rsvp1Fare - self.settings.groundLeg3.value
            } else {
              params.rsvp1Fare = params.rsvp1Fare - (params.rsvp1Fare * (self.settings.groundLeg3.value / 100))
            }
          }
          if (params.rsvp1Fare < 0) params.rsvp1Fare = 0
        }
        if (self.booking.includedLandTranspo.indexOf(3) > -1) {
          params.rsvpId2 = self.tmpBookingID[leg].dropoff
          // params.rsvp2Fare = self.leg4Free ? 0 : self.landFeeDropoffReturnDiscounted
          params.rsvp2Fare = self.leg4Free ? 0 : self.groundFinalPriceTemp[leg].dropoff
          if (self.settings.groundLeg4.value) {
            if (self.settings.groundLeg4.currency === '$') {
              params.rsvp2Fare = params.rsvp2Fare - self.settings.groundLeg4.value
            } else {
              params.rsvp2Fare = params.rsvp2Fare - (params.rsvp2Fare * (self.settings.groundLeg4.value / 100))
            }
          }
          if (params.rsvp2Fare < 0) params.rsvp2Fare = 0
        }
        // if (dropoff.country === 'IND' && self.booking.gozoCabs.leg2Depart) params.rsvp1Gozo = self.gozoIDs.leg2.pickup
        // if (pickup.country === 'IND' && self.booking.gozoCabs.leg2Arrive) params.rsvp2Gozo = self.gozoIDs.leg2.dropoff
      }
      if (params.rsvp1Fare !== null) {
        // params.rsvp1Fare -= this.dcPriceTemp[leg].pickup
        params.rsvp1Fare = parseFloat(params.rsvp1Fare).toFixed(2)
      }
      if (params.rsvp2Fare !== null) {
        // params.rsvp2Fare -= this.dcPriceTemp[leg].dropoff
        params.rsvp2Fare = parseFloat(params.rsvp2Fare).toFixed(2)
      }
      if (self.currency.code !== 'USD') {
        let total = 0
        params.currency = {
          rsvp1: self.leg1Free ? 0 : self.rsvpTotalIntl.ground1,
          rsvp2: self.leg2Free ? 0 : self.rsvpTotalIntl.ground2
        }
        total += params.currency.rsvp1
        total += params.currency.rsvp2
        if (leg === 'leg2') {
          total = 0
          params.currency = {
            rsvp1: self.leg3Free ? 0 : self.rsvpTotalIntl.ground3,
            rsvp2: self.leg4Free ? 0 : self.rsvpTotalIntl.ground4
          }
          total += params.currency.rsvp1
          total += params.currency.rsvp2
        }
        // if (self.isReturning) {
        //   if (leg === 'leg2') {
        //     total = 0
        //     params.currency = {
        //       rsvp1: self.leg3Free ? 0 : self.rsvpTotalIntl.ground3,
        //       rsvp2: self.leg4Free ? 0 : self.rsvpTotalIntl.ground4
        //     }
        //     total += params.currency.rsvp1
        //     total += params.currency.rsvp2
        //   }
        // } else {
        //   if (self.isReturning) {
        //     params.currency.rsvp3 = self.leg3Free ? 0 : self.rsvpTotalIntl.ground3
        //     params.currency.rsvp4 = self.leg4Free ? 0 : self.rsvpTotalIntl.ground4
        //     total += params.currency.rsvp3
        //     total += params.currency.rsvp4
        //   }
        // }
        params.currency.total = total
      }
      // if (self.isReturning) {
      //   params.email = true
      //   params.send = true
      //   params.sms = true
      // }

      if (
        (leg === 'leg1' && self.isReturning && !self.settings.customFlight) ||
        (self.isReturning && leg === 'leg1' && self.settings.customFlight)
      ) {
        params.email = false
        params.send = false
        params.sms = false
      }

      self.$sdk.post2(`${CONFIG.d2dGateway}/d2d/attach`, params, r => {
        try {
          if (r.error) {
            self.$store.commit('other/setOtherData', {appLoader: false, appLoaderMsg: ''})
            self.$store.commit('global/setAlertData', {show: true, message: r.error.message})
            self.$store.commit('booking/setOthersData', {processingFlightSubmit: false})
            trackError.track(self, {
              type: 'd2d/attach',
              data: {
                request: {
                  url: `${CONFIG.d2dGateway}/d2d/attach`,
                  payload: params
                },
                response: r
              }
            })
            self.submitBlocker = false
            return
          }
          let tmpBookingRef = {}
          tmpBookingRef[leg] = {}
          if (!self.booking.flightPending) {
            tmpBookingRef[leg].bookingId = self.tmpCommitBooking.CommitBooking.BookingDetails.BookingId || '?X'
            tmpBookingRef[leg].pnr = self.tmpCommitBooking.CommitBooking.BookingDetails.PNR
          }
          tmpBookingRef[leg].d2dId = r.d2dId
          self.$store.commit('booking/setBookingRefData', tmpBookingRef)
          if (leg === 'leg1' && self.isReturning && !self.settings.customFlight) {
            // self.d2dAttach('leg2')
            // self.d2dCapture('leg2')
            self.beginLandTranspo('leg2')
            return
          }
          if (self.isReturning && leg === 'leg1' && self.settings.customFlight) {
            self.airlineReturnData.active = 'leg2'
            self.submitBlocker = false
            self.initBook(true)
            return
          }
          if (window.gtag) { // eslint-disable-line
            gtag('event', 'D2Dservice - Payment Success') // eslint-disable-line
          }
          // self.$router.push('booking1/complete')
          self.$store.commit('other/setOtherData', {
            appLoader: false,
            appLoaderMsg: ''
          })
          self.$root.$router.push('booking1/complete')
          window.location.href = '#/booking1/complete'
        } catch (error) {
          self.$store.commit('other/setOtherData', {appLoader: false, appLoaderMsg: ''})
          self.$store.commit('global/setAlertData', {show: true, message: 'Something went wrong. Please try again.'})
          self.$store.commit('booking/setOthersData', {processingFlightSubmit: false})
          trackError.track(self, {
            type: 'd2d/attach',
            data: {
              request: {
                url: `${CONFIG.d2dGateway}/d2d/attach`,
                payload: params
              },
              response: '',
              console_error: error
            }
          })
          self.submitBlocker = false
          return
        }
      })
    },
    buildAppReference () {
      let ts = moment().format('x')
      let nanoid = customAlphabet('0123456789', 10)
      let result = 'FB' + ts.substring(0, 2) + '-' + ts.substring(2, 8) + '-' + ts.substring(8) + nanoid(1)
      return result
    },
    back () {
      this.$store.commit('booking/setOthersData', {
        fetch: [
          'Economy',
          'PremiumEconomy',
          'Business',
          // 'PremiumBusiness',
          'First'
        ]
      })
      this.$router.push('d2dservice')
    },
    back2 () {
      if (this.$route.name === 'D2DPaxForm') this.$router.push('D2DItinerary')
      if (this.$route.name === 'Payment') this.$router.push('pax-info')
      if (this.$route.name === 'D2DReview') this.$router.push('Payment')
    },
    showRedeem () {
      this.$store.commit('global/setRedeemData', {show: true})
    },
    toggleGround (x) {
      let self = this
      self.$store.commit('booking/toggleIncludedLandTranspo', x)
      self.$nextTick(() => {
        if (window.gtag) { // eslint-disable-line
          let enable = self.booking.includedLandTranspo.indexOf(x) > -1 ? 'on' : 'off'
          gtag( // eslint-disable-line
            'event',
            'Taxi Check',
            {
              value: enable,
              ground: x + 1
            }
          )
        }
      })
    },
    applyCurrency (x, useSymbol = true) {
      x = parseFloat(x)
      x = x * this.currency.value
      if (!useSymbol) {
        return parseFloat(x.toFixed(2))
      }
      return xcurrency.format({
        code: this.currency.code,
        val: x.toFixed(2)
      }, useSymbol)
    },
    isZero (x) {
      x = parseFloat(x)
      return x <= 0
    },
    sanitizeInput (x) {
      return x.replace(/[\u202A-\u202E]/g, '')
    },
    processGroundGozocabs () {
      this.gozoQueue = []
      if (this.locations.pickup.country === 'IND' && this.booking.gozoCabs.leg1Depart) this.gozoQueue.push({type: 'pickup', leg: 'leg1'})
      if (this.locations.dropoff.country === 'IND' && this.booking.gozoCabs.leg1Arrive) this.gozoQueue.push({type: 'dropoff', leg: 'leg1'})
      if (this.isReturning) {
        if (this.locations.pickup.country === 'IND' && this.booking.gozoCabs.leg2Arrive) this.gozoQueue.push({type: 'dropoff', leg: 'leg2'})
        if (this.locations.dropoff.country === 'IND' && this.booking.gozoCabs.leg2Depart) this.gozoQueue.push({type: 'pickup', leg: 'leg2'})
      }

      if (!this.gozoQueue.length) {
        this.gozoCheck = true
        this.book()
        return
      }

      this.submitGroundGozo()
    },
    submitGroundGozo () {
      let self = this

      if (!self.gozoQueue.length) {
        self.gozoCheck = true
        self.book()
        return
      }

      let quoteData = self.booking.landQuote
      let target = `${self.gozoQueue[0].leg}${self.gozoQueue[0].type === 'pickup' ? 'Depart' : 'Arrive'}`
      // if (self.gozoQueue[0].leg === 'leg2') target = `leg2${self.gozoQueue[0].type === 'pickup' ? 'Depart' : 'Arrive'}`
      let cabin = self.airlines[self.gozoQueue[0].leg].selectedCabin
      quoteData = quoteData[target][cabin]

      let guest = {}
      let guestField = 'infants'
      if (self.filters.travellers.children) guestField = 'children'
      if (self.filters.travellers.adult) guestField = 'adult'
      guest = self.filters.travellers.info[guestField][0]

      let params = {
        token: self.$store.state.user.token,
        tripType: 1,
        cabType: quoteData.id,
        fare: {
          total: quoteData.original.price,
          charged: quoteData.original.price,
          markup: quoteData.markup,
          gst: quoteData.original.gst
        },
        pickupTime: quoteData.pickupTime,
        passengers: self.filters.travellers.total,
        luggage: 0,
        notes: '',
        pickup: quoteData.pickup,
        dropoff: quoteData.dropoff,
        guest: {
          firstName: guest.firstName0,
          lastName: guest.lastName0,
          email: guest.email0,
          contact: {
            countryCode: guest.countryCode0,
            phoneNumber: guest.mobile0
          }
        }
      }
      self.$sdk.post2(`${CONFIG.d2dGateway}/d2d/gozocabs`, params, r => {
        if (r.error) {
          self.$store.commit('other/setOtherData', {appLoader: false, appLoaderMsg: ''})
          self.$store.commit('global/setAlertData', {show: true, message: r.error.message})
          self.$store.commit('booking/setOthersData', {processingFlightSubmit: false})
          trackError.track(self, {
            type: 'hold gozocabs',
            data: {
              request: {
                route: '/d2d/gozocabs',
                payload: params
              },
              response: r
            }
          })
          return
        }

        self.gozoIDs[self.gozoQueue[0].leg][self.gozoQueue[0].type] = r.bookingId
        self.gozoQueue.shift()
        self.submitGroundGozo()
      })
    },
    dcLabel (x) {
      if (x.currency === '$') return `${x.currency}${x.value}`
      return `${x.value}${x.currency}`
    },
    getTimezone (type, leg) {
      let self = this
      let legData = self.buildLeg(type, leg)
      let url = 'https://revgeocode.search.hereapi.com/v1/revgeocode?at={AT}&lang=en-US&apiKey={API_KEY}&show=tz'
      url = url.replace('{AT}', encodeURIComponent(legData.pickup.lat + ',' + legData.pickup.lng))
        .replace('{API_KEY}', CONFIG.hereApi.key)
      request.get({
        url: url,
        json: true
      }, function (err, res, body) {
        try {
          if (err) {
            console.log('timezone err:', err)
            return
          }
          if (body.items.length) {
            self.$store.commit('reservation/addTimezone', {
              lat: legData.pickup.lat,
              lng: legData.pickup.lng,
              timezone: body.items[0].timeZone.name
            })
          }
        } catch (error) {
          console.log('timezone err:', error)
        } finally {
          self.submitRsvp(type, leg)
        }
      })
    }
  },
  watch: {
    _route (x) {
      // if (x === 'D2DReview') {
      // }
    },
    _includedLandTranspo (x) {
      this.ground0 = x.indexOf(0) > -1
      this.ground1 = x.indexOf(1) > -1
      this.ground2 = x.indexOf(2) > -1
      this.ground3 = x.indexOf(3) > -1
    }
  },
  mounted () {
    this.ground0 = this.booking.includedLandTranspo.indexOf(0) > -1
    this.ground1 = this.booking.includedLandTranspo.indexOf(1) > -1
    if (this.isReturning) {
      this.ground2 = this.booking.includedLandTranspo.indexOf(2) > -1
      this.ground3 = this.booking.includedLandTranspo.indexOf(3) > -1
    }
  }
}
</script>

<style lang="scss" scoped>
.summary-box{
  width: 100%;
}
.computation-box{
  border: 1px solid #abb2b8;
  border-radius: 6px;
  padding: 25px 20px;
  background: #fff;
  margin-bottom: 20px;

  table{
    width: 100%;
    margin-bottom: 20px;

    .td-label{
      b{
        font-size: 15px;
        line-height: 1;
        display: block;
        margin-bottom: 2px;

        i{
          margin-right: 5px;
        }
      }
      span{
        font-size: 13px;
        letter-spacing: .5px;
        color: #5E6E7F;
        display: inline-block;
        line-height: 1;
      }
    }
    .val{
      text-align: right;
      width: 100px;

      &.sb{
        color: #aaa;
      }

      .free-label{
        background: #f14c4c;
        color: #fff;
        font-weight: 600;
        font-size: 12px;
        padding: 3px 5px;
        border-radius: 3px;
        display: inline-block;
        margin-bottom: 3px;
      }
      .ground-price{
        color: #999;
        text-decoration: line-through;
        text-decoration-color: red;
      }
    }
    hr{
      margin: 25px 0;
      border: none;
      border-top: 1px solid #d1d3d5;
    }
    .ground-service{
      line-height: 1;
      td{
        padding-top: 20px;
        padding-bottom: 3px;
      }
      .gs-check{
        width: 60px;
      }
      img{
        width: 30px;
        margin-right: 5px;
        vertical-align: 0px;
      }
      input{
        margin-right: 5px;
      }
      .gs-name{
        letter-spacing: .6px;
      }
      .val{
        font-size: 14px;
      }
      &.removed{
        .gs-name,
        .val{
          opacity: .5;
          filter: blur(.8px);
        }
      }
    }
    .ground-loc{
      line-height: 1.3;
      font-size: 12px;
      margin-bottom: 7px;
      letter-spacing: .5px;
      color: #5E6E7F;
      &.removed{
        opacity: .5;
        filter: blur(.8px);
      }
    }
    .removed{
      .gs-name,
      .val,
      .gl-loc{
        transition: all .3s ease;
      }
    }
    .tr-tax{
      i{
        margin-left: 5px;
      }
    }
    .total{
      font-size: 18px;
      font-weight: 600;
      line-height: 1;

      td{
        // border-top: 1px solid #ccc;
        padding-top: 10px;
      }
      .incl-taxes{
        display: block;
        font-size: 10px;
        font-weight: 400;
        letter-spacing: .5px;
        color: #555;
        margin-top: 2px;
      }
    }
    .credits{
      .val span{
        color: #f00;
      }
    }
  }
  .redeem{
    color: #ff9c09;
    font-size: 12px;
    letter-spacing: .6px;
    text-decoration: underline;
    font-style: italic;
    cursor: pointer;
    padding-bottom: 10px;
  }
}
.cb-title{
  font-size: 21px;
  font-weight: 600;
  margin-bottom: 20px;
}
.lr-btn{
  border-radius: 20px;
}
.tr-breakdown{
  // color: #999;
  font-size: 13px;

  .flight-icon{
    width: 30px;
    margin-right: 7px;
  }
  .check{
    width: 60px;

    img{
      width: 30px;
      margin-right: 5px;
      vertical-align: 0px;
    }
    input{
      margin: 4px 0 0;
    }
  }
  .td-loc{
    line-height: 1.3;
    padding-bottom: 10px;
    letter-spacing: .5px;
  }
  .pickup-loc {
    font-size: 9px;
    display: block;
  }
  &.removed{
    color: #c1c1c1;
    b{
      font-weight: 100;
    }
  }
  .upto{
    font-size: 12px;
  }
  .dc-txt{
    color: #ff0909
  }
}
.change-flight{
  display: block;
  text-align: center;
  font-size: 16px !important;
  color: #7d94a9 !important;
  margin-top: 15px;
  text-decoration: underline;
}
.disclaimer-box{
  margin-bottom: 20px;
  font-size: 13px;
  color: #777;
  text-align: justify;
  padding: 0 10px;
  line-height: 1.4;
  font-style: italic;
}

@media only screen and (max-width: 40em) {
  .summary-box {
    width: auto;
    margin-bottom: 20px;
    margin-top: 25px;

    &.no-top{
      margin-top: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// PaymentSummary.vue?5838b7e0